<template>
  <div class="text-xs md:text-header-window">
    <div class="flex w-full text-xxs md:text-xs items-center justify-center md:justify-start ml-px flex-wrap gap-4 md:min-w-80 md:ml-1">
      <div class="flex flex-col items-center flex-wrap">
        <img src="/img/icons/projects/tools/capcut.png" :alt="$t('common.icon') + ' php'" class="w-9 h-9" />
        <p class="font-bold">Capcut</p>
      </div>
      <div class="flex flex-col items-center flex-wrap">
        <img src="/img/icons/projects/tools/premiere-pro.png" :alt="$t('common.icon') + ' javascript'" class="w-9 h-9" />
        <p class="font-bold">PremierePro</p>
      </div>
    </div>
    <h3 class="mt-5 mb-2">{{ $t('common.context') }}</h3>
    <p>
      {{ $t('project.flashbackzone.contextFirstParagraph') }}
    </p>
    <br />
    <p>
      {{ $t('project.flashbackzone.contextSecondParagraph') }}
    </p>
    <br />
    <p>
      {{ $t('project.flashbackzone.contextThirdParagraph') }}
    </p>
    <br />
    <p>
      {{ $t('project.flashbackzone.contextFourthParagraph') }}
    </p>
    <p>
    <br />
    <br />
      {{ $t('project.flashbackzone.postscriptum') }}
    </p>
    <br />
    <div
      class="w-full justify-center mt-5 mb-2 flex flex-row items-center gap-0.5 cursor-pointer transition-all hover:underline hover:text-heroic-blue hover:fill-heroic-blue">
      <img src="/img/icons/projects/tools/neocities.png" :alt="$t('common.icon') + ' php'" class="w-5 h-5" />
      <a rel="noopener" href="https://xclusivetest.neocities.org/accueil" target="_blank" class="cursor-pointer">
        {{$t('buttons.linkNeo') }}
      </a>
    </div>
  </div>
</template>
